export default {
  ANSWER_TYPE: { TEXT: 0, IMAGE: 1, STT: 2 },
  ANSWER_TYPE_DROPDOWN: [
    { name: 'TEXT', value: 0 },
    { name: 'IMAGE', value: 1 },
    { name: 'STT', value: 2 },
  ],
};
